// extracted by mini-css-extract-plugin
module.exports = {"annimation":"LoadingModule-module-annimation"};